module.exports = __webpack_public_path__ + "img/icon-62.470704dd.png";